import { forwardRef } from 'react';
import { cx } from '@linaria/atomic';
import { Hint } from '../hint/hint.component';
import type { HintUIProps } from '../hint/hint.component';
import { hoverLabelBaseStyle, hoverLabelThemeStyles } from './hover-label.styles';
import { ThemeProps } from './types';

type Props = HintUIProps & Partial<ThemeProps>;

export const HoverLabel = forwardRef<HTMLParagraphElement, Props>(({ theme = 'dark', className, ...rest }, ref) => {
  return <Hint className={cx(hoverLabelBaseStyle, hoverLabelThemeStyles[theme], className)} {...rest} ref={ref} />;
});
